import React from "react";
import { useTranslation } from "react-i18next";

import { areSexAndGenderPrePopulated } from "@/utils/survey/retriage";
import { shouldShowDefaultSexAndGenderQuestions } from "@/utils/survey/sexAndGender";

import {
  QuestionComponentProps,
  QuestionDefinition,
  QuestionOption,
} from "../../Question";
import { MultipleChoiceQuestion } from "../core";

const QUESTION_ID = "gender";
export const GENDER_QUESTION_ID = QUESTION_ID;

declare module "@/contexts" {
  interface SurveyAnswers {
    gender?: string;
  }
}

const GenderQuestion: React.FC<QuestionComponentProps> = ({
  onClickBack,
  onClickNext,
  surveyAnswers,
}) => {
  const { t } = useTranslation();

  const options: QuestionOption[] = [
    { id: "male", text: t("gender.options.male") },
    { id: "female", text: t("gender.options.female") },
    { id: "transgender", text: t("gender.options.transgender") },
    { id: "other", text: t("gender.options.other") },
    { id: "preferNotToSay", text: t("gender.options.preferNotToSay") },
  ];

  return (
    <MultipleChoiceQuestion
      onClickBack={onClickBack}
      onClickNext={onClickNext}
      options={options}
      questionId={QUESTION_ID}
      questionText={t("gender.questionText")}
      selectedItem={surveyAnswers[QUESTION_ID] || ""}
    />
  );
};

export const Q_GENDER: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: [
    "WEIGHT",
    "MOOD",
    "DPP",
    "DIABETES_LIFESTYLE",
    "MED",
    "NMPBA",
  ],
  shouldShowQuestion: ({ eligibilityInfo, partnerInfo }) =>
    shouldShowDefaultSexAndGenderQuestions(
      partnerInfo?.id,
      eligibilityInfo?.segmentId,
    ),
  component: GenderQuestion,
};

export const Q_RETRIAGE_GENDER: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: ["DPP", "DIABETES_LIFESTYLE", "MED", "NMPBA"],
  shouldShowQuestion: ({
    retriageEligibility,
    surveyAnswers,
    partnerInfo,
    eligibilityInfo,
  }) => {
    const showDefaultQuestions = shouldShowDefaultSexAndGenderQuestions(
      partnerInfo?.id,
      eligibilityInfo
        ? eligibilityInfo.segmentId
        : retriageEligibility?.segmentId,
    );
    if (!showDefaultQuestions) {
      return false;
    }
    return !areSexAndGenderPrePopulated(surveyAnswers, retriageEligibility);
  },
  component: GenderQuestion,
};
